import React from "react"

export const AnchorPoint = ({ data }) => {
  const { anchorId } = data

  return (
    <div>
      <a id={anchorId}></a>
    </div>
  )
}
